import {
  Warehouse,
  MapPin,
  Truck,
  Sparkles,
  AlertTriangle,
  Clock,
} from "lucide-react";

import { Card, CardContent } from "~/components/ui/card";
import { TotemStats } from "~/services/totemService";

interface TotemStatsCardsProps {
  stats: TotemStats;
  // Open shortfall alarms (totems invoiced without available stock).
  pendingCount?: number;
  isLoading?: boolean;
}

export function TotemStatsCards({
  stats,
  pendingCount = 0,
  isLoading,
}: TotemStatsCardsProps) {
  const cards = [
    {
      label: "Disponibles",
      value: stats.available + stats.filled,
      icon: Warehouse,
      color: "text-green-600",
      bgColor: "bg-green-50",
    },
    {
      label: "En Clientes",
      value: stats.at_client + stats.pickup_ready + stats.pickup_scheduled,
      icon: MapPin,
      color: "text-blue-600",
      bgColor: "bg-blue-50",
    },
    {
      label: "Uso Interno",
      value: stats.in_transit + stats.pickup_transit,
      icon: Truck,
      color: "text-cyan-600",
      bgColor: "bg-cyan-50",
    },
    {
      label: "En Limpieza",
      value: stats.returned + stats.cleaning,
      icon: Sparkles,
      color: "text-purple-600",
      bgColor: "bg-purple-50",
    },
  ];

  if (stats.damaged + stats.lost > 0) {
    cards.push({
      label: "Con Problemas",
      value: stats.damaged + stats.lost,
      icon: AlertTriangle,
      color: "text-red-600",
      bgColor: "bg-red-50",
    });
  }

  if (pendingCount > 0) {
    cards.push({
      label: "Pendientes",
      value: pendingCount,
      icon: Clock,
      color: "text-amber-600",
      bgColor: "bg-amber-50",
    });
  }

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-4">
      {cards.map((card) => (
        <Card key={card.label} className={`${card.bgColor} border-0`}>
          <CardContent className="p-4">
            <div className="flex items-start justify-between">
              <div>
                <p className="text-sm font-medium text-muted-foreground">
                  {card.label}
                </p>
                <p className={`text-2xl font-bold ${card.color}`}>
                  {isLoading ? "-" : card.value}
                </p>
              </div>
              <card.icon className={`h-5 w-5 ${card.color}`} />
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
